import axios from '@/axios';

const actions = {

  async getAll({ commit }, { depotId, indentIds }) {
    try {
      commit('SET_WALLET_LOADING', true);
      const result = await axios(`wallet/${depotId}`, { params: { indentIds } });
      commit('SET_WALLET', result.data);
      return result.data;
    } catch (err) {
      return err;
    } finally {
      commit('SET_WALLET_LOADING', false);
    }
  },
  async listForTransporters({ commit }, params) {
    try {
      commit('SET_WALLET_TRANSPORTER_LIST_LOADING', true);
      const result = await axios('/wallet/transporter/list', { params });
      if (result && result.data) {
        commit('SET_WALLET_TRANSPORTER_LIST', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    } finally {
      commit('SET_WALLET_TRANSPORTER_LIST_LOADING', false);
    }
  },
  async exportWallet({ commit }, { month, year }) {
    try {
      const result = await axios({ url: `/wallet/transporter/export?month=${month}&year=${year}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `wallet-export-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      return error;
    } finally {
      commit('SET_WALLET_TRANSPORTER_LIST_LOADING', false);
    }
  },

};

export default actions;
